import $ from 'jquery'
import mountComponent from '../services/mountReactRedux'

$(mountComponent)
